import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const URL = `${API_BASE}/api/ordenescompra`;

export async function obtenerSiguienteFolioOC(empresa) {
  const { data } = await axios.get(`${URL}/siguiente-folio`, { params: { empresa } });
  return data;
}

export async function obtenerListaOC({ empresa, page = 1, pageSize = 20, search = "" }) {
  const { data } = await axios.get(URL, { params: { empresa, page, pageSize, search } });
  return data; // { total, page, pageSize, items }
}

export async function obtenerOrdenCompra(id, empresa) {
  const { data } = await axios.get(`${URL}/${id}`, { params: { empresa } });
  return data;
}

export async function crearOrdenCompra(payload) {
  const { data } = await axios.post(URL, payload);
  return data;
}

export async function actualizarOrdenCompra(id, payload) {
  const { data } = await axios.put(`${URL}/${id}`, payload);
  return data;
}

export async function cancelarOrdenCompra(id, empresa) {
  const { data } = await axios.delete(`${URL}/${id}`, { params: { empresa } });
  return data;
}
